import { isNull, isObject, isUndefined } from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ROLE_PHD_ADMIN } from '../utils/constants/roles.js';

const normalizeRoleName = (name) =>
  String(name || '')
    .toLowerCase()
    .replace(/[.\s]+/g, ' ')
    .trim();

function useIsUserPhdAdmin() {
  const user = useSelector(state => state.auth.user);

  return useMemo(() => {
    if (!isObject(user) || isNull(user) || isUndefined(user)) {
      return false;
    }

    const roleMatch = Array.isArray(user.roles) && user.roles.some((role) => {
      const roleName = typeof role === 'string' ? role : role?.name;
      return normalizeRoleName(roleName) === normalizeRoleName(ROLE_PHD_ADMIN);
    });

    // Fallback for environments where role labels differ but PhD admin permissions are present.
    const permissionMatch = isObject(user.permissions) && user.permissions !== null
      ? 'phd-system-states.store' in user.permissions
      : false;

    return roleMatch || permissionMatch;
  }, [user]);
}

export default useIsUserPhdAdmin;
